import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { FilterComponent } from './filter-button/filter.component';
import { FilterRoomsComponent } from './filter-panel/filter.component';
import { FilterTagsComponent } from './filter-tags/filter-tags.component';
import { FilterSection } from './mobile-filters/section/filter-section';
import { MobileFiltersComponent } from './mobile-filters/mobile-filters';
import { DesktopFiltersComponent } from './mobile-filters/desktop-filters';
import { FilterPanel } from './mobile-filters/panel/filter-panel';
import { FzChip, ChipGroup } from '@fantaz/shared/ui/chip';
import { CurrentRefinementList } from '@fantaz/shared/ui/filters';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MaterialModule,
    MatCheckboxModule,
    MatIconModule,
    FzChip,
    ChipGroup,
    CurrentRefinementList,
  ],
  declarations: [
    FilterComponent,
    FilterRoomsComponent,
    FilterTagsComponent,
    FilterSection,
    MobileFiltersComponent,
    DesktopFiltersComponent,
    FilterPanel,
  ],
  exports: [
    FilterComponent,
    FilterRoomsComponent,
    FilterTagsComponent,
    FilterSection,
    MobileFiltersComponent,
    DesktopFiltersComponent,
    FilterPanel,
  ],
  providers: [
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        hideSingleSelectionIndicator: true,
      },
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class TournamentsUiFilterModule {}
